import buildVersion from '@env/buildVersion';
import { BuildVersion, IEnvironment } from './environment.interface';

const gatewayUrl = 'https://api-document-gateway.portalstg2.mynexuscare.com';
const platformApiUrl = 'https://api-platform.portalstg2.mynexuscare.com';

export const environment: IEnvironment = {
  gatewayUrl,
  platformApiUrl,
  modules: [],
  production: false,
  routes: [],
  version: buildVersion as BuildVersion,
};
